import {Modal, Button} from "react-bootstrap";
import clothesData from "./traits/clothes.json";
import shoesData from "./traits/shoes.json";
import handToolsData from "./traits/hand-tools.json";
import glovesData from "./traits/gloves.json";
import hairData from "./traits/hair.json";
import hatData from "./traits/hat.json";
import faceHairData from "./traits/face-hair.json";
import glassesData from "./traits/glasses.json";
import {useState, useRef} from "react";

import html2canvas from 'html2canvas';

function BaseImage(props: { file: string }) {
    const src = `/traits/${props.file}`
    return <img src={src}/>;
}

interface Props {
    width: string,
    height: string,
    clothes: number;
    shoes: number;
    handTools: number;
    gloves: number;
    hair: number;
    hat: number;
    faceHair: number;
    glasses: number;
}

function FarmerImage(props: Props) {
    const [details, setDetails] = useState(false);

    const showDetails = () => {
        setDetails(true);
    }

    const hideDetails = () => {
        setDetails(false);
    }

    const _clothes = clothesData.find(x => x.id === props.clothes);
    const _shoes = shoesData.find(x => x.id === props.shoes);
    const _handTools = handToolsData.find(x => x.id === props.handTools);
    const _gloves = glovesData.find(x => x.id === props.gloves);
    const _hair = hairData.find(x => x.id === props.hair);
    const _hat = hatData.find(x => x.id === props.hat);
    const _faceHair = faceHairData.find(x => x.id === props.faceHair);
    const _glasses = glassesData.find(x => x.id === props.glasses);

    const elm = useRef<HTMLDivElement | null>(null);

    return <div className="FarmerImage" style={{width: props.width, height: props.height}} ref={elm}>
        <div className="layer_0"><BaseImage file="body.png"/></div>
        {_clothes && <div className="layer_1"><BaseImage file={_clothes.file}/></div>}
        {_shoes && <div className="layer_2"><BaseImage file={_shoes.file}/></div>}
        {_handTools && <div className="layer_3"><BaseImage file={_handTools.file}/></div>}
        {_gloves && <div className="layer_4"><BaseImage file={_gloves.file}/></div>}
        {_hair && <div className="layer_5"><BaseImage file={_hair.file}/></div>}
        {_glasses && <div className="layer_6"><BaseImage file={_glasses.file}/></div>}
        {_faceHair && <div className="layer_7"><BaseImage file={_faceHair.file}/></div>}
        {_hat && <div className="layer_8"><BaseImage file={_hat.file}/></div>}
        <div className="layer_9" onClick={showDetails}/>
        <div className="download-button" onClick={() => {
            if (!elm.current) {
                return;
            }

            const width = elm.current.style.width;
            const height = elm.current.style.height;

            elm.current.style.width = '1000px';
            elm.current.style.height = '1000px';

            html2canvas(elm.current, {backgroundColor:null}).then(canvas => {
                elm.current!.style.width = width;
                elm.current!.style.height = height;

                canvas.toBlob((blob) => {
                    if (!blob) {
                        return;
                    }

                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = 'farmer.png';
                    a.click();

                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }, 50)
                }, "image/png", 100);
            })
        }}>
            <Button>Download</Button>
        </div>

        {details && <>
          <Modal show={true} onHide={hideDetails}>
            <Modal.Header closeButton>
              <Modal.Title>Traits</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-trait-list">
                  {_clothes && <div className="modal-trait-detail"><h5>Clothes: {_clothes.name}</h5> <BaseImage
                      file={_clothes.file}/>
                  </div>}
                  {_shoes && <div className="modal-trait-detail"><h5>Shoes: {_shoes.name}</h5> <BaseImage
                      file={_shoes.file}/>
                  </div>}
                  {_handTools && <div className="modal-trait-detail"><h5>Hand Tools: {_handTools.name}</h5> <BaseImage
                      file={_handTools.file}/>
                  </div>}
                  {_gloves && <div className="modal-trait-detail"><h5>Gloves: {_gloves.name}</h5> <BaseImage
                      file={_gloves.file}/>
                  </div>}
                  {_hair && <div className="modal-trait-detail"><h5>Hair: {_hair.name}</h5> <BaseImage
                      file={_hair.file}/>
                  </div>}
                  {_hat && <div className="modal-trait-detail"><h5>Hat: {_hat.name}</h5> <BaseImage
                      file={_hat.file}/>
                  </div>}
                  {_faceHair && <div className="modal-trait-detail"><h5>Face Hair: {_faceHair.name}</h5> <BaseImage
                      file={_faceHair.file}/>
                  </div>}
                  {_glasses && <div className="modal-trait-detail"><h5>Glasses: {_glasses.name}</h5> <BaseImage
                      file={_glasses.file}/>
                  </div>}
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary">Close</Button>
            </Modal.Footer>
          </Modal>
        </>}
    </div>
}

export default FarmerImage;